<template>
  <div>
    <MainForm
      :name="FORM_NAMES.loanOfferRejected"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      :ui-form="uiForm"
      ui-title="Reject offer"
    >
      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.feedback"
        ui-error-message="Please review the fields marked in red"
        ui-button-text="Thanks"
        ui-feedback="We are sorry that you did not accept our offer. What can we do better?"
      >
        <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.feedback">
          <UiWrapper :name="FIELD_NAMES.feedback">
            <Dropdown
              placeholder="Choose your reason for rejecting our offer."
              :options="FEEDBACK_OPTIONS"
            />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>

<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";

import * as conditions from "@/forms/conditions";

import { Dropdown } from "@dunia/ui";

import UiWrapper from "@/forms/components/base/ui-wrapper";

export default {
  name: "OfferRejected",

  mixins: [FormComponentMixin],

  data: () => ({
    FEEDBACK_OPTIONS: [
      {
        value: "I want a higher loan amount",
        label: "I want a higher loan amount"
      },
      {
        value: "I want a lower interest rate",
        label: "I want a lower interest rate"
      },
      {
        value: "I was not given all the information about the loan",
        label: "I was not given all the information about the loan"
      },
      {
        value: "I applied for a loan from another bank",
        label: "I applied for a loan from another bank"
      },
      {
        value: "I changed my mind",
        label: "I changed my mind"
      }
    ]
  }),

  components: {
    MainForm,
    StepModel,
    FieldsetModel,
    UiWrapper,
    Dropdown
  },

  methods: {
    ...conditions,
    finishCallback() {
      this.showEndPage({
        title: `Thanks for your feedback, ${this.userName}!`,
        subtitle:
          "If you have any doubts, please, don't hesitate to contact us.",
        actionNameEndForm: "Close"
      });
    }
  }
};
</script>
